import lo from 'lodash';
import axios from 'axios';

import configs from 'configs';
import { queryURL } from 'utils';

import storage from 'utils/storage';
import { UserRole } from 'utils/enums';
import { getUserRole, getAppRole } from 'utils/authorize';

import { getSpaceToken, getUserProfile, getUsersInSpace, getSpaceSettings } from '../services/app';

const ACCESS_TOKEN = 'accessToken';
const SPACE_TOKEN = 'spaceToken';
const CURRENT_SPACE = 'currentSpace';


const { authorizationUrl, clientId, tokenHandleUrl, logoutUrl } = configs;

const fullMenu = [
  { id: '1', mpid: '-1', name: 'Quản lý file', icon: 'folder', route: '/' },
  { id: '14', name: 'Quản lý file', icon: 'folder', route: '/file' },
  { id: '16', name: 'Thảo luận', icon: 'message', route: '/comment' },

  { id: '2', name: 'Tổng hợp', icon: 'book', route: '/general' },

  { id: '3', name: 'Mua hàng', icon: 'shopping-cart', route: '/purchase' },
  { id: '4', name: 'Bán hàng', icon: 'shop', route: '/sale' },
  { id: '5', name: 'Phân bổ chi phí', icon: 'calculator', route: '/expense' },

  { id: '6', name: 'Kho hàng', icon: 'inbox', route: '/inventory1' },
  { id: '6.1', mpid: '6', name: 'Báo cáo kho', route: '/inventory' },
  { id: '6.2', mpid: '6', name: 'Phiếu xuất kho', route: '/inventory/entry' },

  { id: '7', name: 'Ngân hàng', icon: 'bank', route: '/bank' },
  { id: '7.1', mpid: '7', name: 'Giao dịch', route: '/bank/transaction' },
  { id: '7.2', mpid: '7', name: 'Đồng bộ công nợ', route: '/bank/debt' },

  { id: '8', name: 'Lương', icon: 'idcard', route: '/salary' },
  { id: '8.1', mpid: '8', name: 'Nhân viên', route: '/employee' },
  { id: '8.2', mpid: '8', name: 'Bảng lương', route: '/salary/data' },
  { id: '8.3', mpid: '8', name: 'Bảo hiểm', route: '/salary/insurance' },

  { id: '9', name: 'Giá vốn', icon: 'export', route: '/cost' },
  { id: '9.1', mpid: '9', name: 'Chi phí', route: '/cost/expense-distribution' },
  { id: '9.2', mpid: '9', name: 'Định mức', route: '/cost/norm' },
  { id: '9.3', mpid: '9', name: 'Thành phẩm', route: '/cost/finished-good' },
  { id: '9.4', mpid: '9', name: 'Hóa đơn', route: '/cost/sale' },

  { id: '10', name: 'Dữ liệu', icon: 'database', route: '/support-data' },
  { id: '10.1', mpid: '10', name: 'Đối tác', route: '/contact' },
  { id: '10.2', mpid: '10', name: 'Mặt hàng', route: '/item' },
  { id: '10.3', mpid: '10', name: 'Kế toán', route: '/data' },
  { id: '10.4', mpid: '10', name: 'Xuất file', route: '/export' },

  { id: '11', name: 'Báo cáo', icon: 'area-chart', route: '/report' },
  { id: '11.1', mpid: '11', name: 'Tổng quan', route: '/report/general' },

  { id: '11.2', mpid: '11', name: 'Cảnh báo', route: '/report/notice' },
  { id: '11.3', mpid: '11', name: 'Kê khai thuế', route: '/report/tax' },

  { id: '11.4', mpid: '11', name: 'Lập BCTC', route: '/report' },
  { id: '11.4.1', mpid: '11.4', name: 'Phân tích chi phí', route: '/report/analysis' },
  { id: '11.4.2', mpid: '11.4', name: 'Bảng cân đối TK', route: '/report/accounts-balance' },
  { id: '11.4.2.1', mpid: '-1', bpid: '11.4.2', name: 'Sổ cái tài khoản', route: '/report/account-ledger/:account_id' },
  { id: '11.4.3', mpid: '11.4', name: 'Báo cáo tài chính', route: '/report/financial' },
  { id: '11.4.4', mpid: '11.4', name: 'Thuế TNDN', route: '/report/corp-income-tax' },
  { id: '11.4.5', mpid: '11.4', name: 'Thuế TNCN', route: '/report/employee-income-tax' },
  { id: '11.4.6', mpid: '11.4', name: 'Thuyết minh BCTC', route: '/report/financial-detail' },

  { id: '17', name: 'Phí dịch vụ', icon: 'wallet', route: '/payment' },
  { id: '12', name: 'Thiết lập', icon: 'setting', route: '/settings' },

  { id: '13', mpid: '-1', name: 'Chuyển sổ kế toán', route: '/space' },
  { id: '15', mpid: '-1', name: 'Hoạt động', route: '/activity' },
  { id: '16', mpid: '-1', name: 'Báo cáo thuế', route: '/space/report' },
];

const readonlyMenu = [
  { id: '1', mpid: '-1', name: 'Quản lý file', icon: 'folder', route: '/' },
  { id: '14', name: 'Quản lý file', icon: 'folder', route: '/file' },
  { id: '16', name: 'Thảo luận', icon: 'message', route: '/comment' },

  { id: '11.1', icon: 'area-chart', name: 'Tổng quan', route: '/report/general' },
  { id: '11.2', icon: 'contacts', name: 'Công nợ', route: '/report/debt' },
  { id: '11.3', icon: 'appstore', name: 'Kê khai thuế', route: '/report/tax' },

  { id: '11.4', icon: 'calculator', name: 'Lập BCTC', route: '/report' },
  { id: '11.4.1', mpid: '11.4', name: 'Phân tích chi phí', route: '/report/analysis' },
  { id: '11.4.2', mpid: '11.4', name: 'Bảng cân đối TK', route: '/report/accounts-balance' },
  { id: '11.4.2.1', mpid: '-1', bpid: '11.4.2', name: 'Sổ cái tài khoản', route: '/report/account-ledger/:account_id' },
  { id: '11.4.3', mpid: '11.4', name: 'Báo cáo tài chính', route: '/report/financial' },
  { id: '11.4.4', mpid: '11.4', name: 'Thuế TNDN', route: '/report/corp-income-tax' },
  { id: '11.4.5', mpid: '11.4', name: 'Thuế TNCN', route: '/report/employee-income-tax' },
  { id: '11.4.6', mpid: '11.4', name: 'Thuyết minh BCTC', route: '/report/financial-detail' },

  { id: '10.5', icon: 'export', name: 'Xuất file', route: '/export' },
  { id: '17', name: 'Phí dịch vụ', icon: 'wallet', route: '/payment' },

  { id: '3', mpid: '-1', name: 'Mua hàng', icon: 'shopping-cart', route: '/purchase' },
  { id: '4', mpid: '-1', name: 'Bán hàng', icon: 'shop', route: '/sale' },
  { id: '13', mpid: '-1', name: 'Chuyển sổ kế toán', route: '/space' },
  { id: '15', mpid: '-1', name: 'Hoạt động', route: '/activity' },

];

export default {
  namespace: 'app',
  state: {
    message: {}, // {type, content, timeout}
    user: {},
    userRole: 'null',
    users: {},
    settings: {},
    menu: [],
    menuPopoverVisible: false,
    siderFold: storage.getItem('siderFold') === 'true',
    darkTheme: storage.getItem('darkTheme') === 'true',
    isNavbar: document.body.clientWidth < 769,
    navOpenKeys: JSON.parse(storage.getItem('navOpenKeys')) || [],
    accountingPeriod: storage.getAccountingPeriod(),
    beginPeriod: storage.getAccountingPeriod(),
  },
  subscriptions: {

    setup({ dispatch }) {
      if (window.location.pathname === '/logout') {
        storage.removeItem(ACCESS_TOKEN);
        storage.removeItem(SPACE_TOKEN);
        window.location = '/';
        return;
      }

      if (window.location.pathname === '/open-space') {
        const spaceId = queryURL('spaceId');

        if (spaceId) {
          storage.setItem(CURRENT_SPACE, spaceId);
          // clear token
          storage.removeItem(SPACE_TOKEN);

          const period = queryURL('period');
          if (period) {
            storage.setItem('period', period);
          }

          const continueUrl = queryURL('continue');
          if (continueUrl) {
            storage.setItem('continueUrl', continueUrl);
            window.location = continueUrl;
          } else {
            window.location = '/';
          }
        } else {
          dispatch({ type: 'setMessage', payload: { type: 'error', content: 'Mã sổ kế toán không hợp lệ', duration: 20 } });
        }
        return;
      }

      if (window.location.pathname === '/auth/token') {
        const accessToken = queryURL('access_token');
        if (accessToken) {
          storage.setItem(ACCESS_TOKEN, accessToken);
          window.location = '/';
        } else {
          dispatch({ type: 'setMessage', payload: { type: 'error', content: 'Token không hợp lệ', duration: 2 } });
        }
        return;
      }

      const accessToken = storage.getItem(ACCESS_TOKEN);
      if (!accessToken) {
        // redirect to login
        window.location = `${authorizationUrl}?response_type=token&client_id=${clientId}&redirect_uri=${tokenHandleUrl}&scope=dha`;
      } else {
        console.log('saved access token', accessToken);
        axios.defaults.headers.common['X-DHA-Period'] = storage.getAccountingPeriod();
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
        const spaceToken = storage.getItem(SPACE_TOKEN);
        if (!spaceToken) {
          // get space token
          const spaceId = storage.getItem(CURRENT_SPACE) || 'default';
          dispatch({ type: 'getSpaceToken', payload: { spaceId } });
        } else {
          console.log('saved space token:', spaceToken);
          // set default header
          axios.defaults.headers.common.Authorization = `Bearer ${spaceToken}`;

          // get user profile from auth server
          dispatch({ type: 'getUserProfile' });

          let tid;
          window.onresize = () => {
            clearTimeout(tid);
            tid = setTimeout(() => {
              dispatch({ type: 'changeNavbar' });
            }, 300);
          };
        }
      }
    },

  },
  effects: {
    * getSpaceToken({ payload }, { call, put }) {
      const data = yield call(getSpaceToken, payload);
      const { success, token } = data;
      if (success && token && token.value) {
        console.log('space token:', token);
        storage.setItem(SPACE_TOKEN, token.value);
        const continueUrl = storage.getItem('continueUrl');
        if (continueUrl) {
          window.location = continueUrl;
          storage.removeItem('continueUrl');
        } else {
          window.location = '/';
        }
      } else {
        storage.removeItem(CURRENT_SPACE);
        yield put({ type: 'setMessage', payload: { type: 'error', content: 'Bạn chưa được phân quyền để truy cập trang này. Vui lòng liên hệ để được hỗ trợ!', duration: 600 } });
        yield put({ type: 'logout', payload: 5000 });
      }
    },
    * getUserProfile({ payload, output }, { call, put }) {
      const data = yield call(getUserProfile, payload);
      output && (output.value = data);
      const { success, user } = data;
      const role = getUserRole(user);
      if (success && role) {
        yield put({
          type: 'setUserProfile',
          payload: user,
        });
        yield put({ type: 'initData' });
      } else {
        storage.removeItem(CURRENT_SPACE);
        yield put({ type: 'setMessage', payload: { type: 'error', content: 'Bạn không có quyền truy cập trang này. Vui lòng liên hệ để được hỗ trợ!', duration: 4 } });
        yield put({ type: 'logout', payload: 5000 });
      }
    },
    * getSpaceSettings({ payload }, { call, put }) {
      const { success, settings } = yield call(getSpaceSettings, payload);
      if (success && settings) {
        yield put({
          type: 'setSpaceSettings',
          payload: settings,
        });
      }
    },
    * getSpaceUsers({ payload }, { call, put }) {
      const { success, users } = yield call(getUsersInSpace, payload);
      if (success && users) {
        yield put({
          type: 'setSpaceUsers',
          payload: users,
        });
      }
    },
    * logout({ payload }, { put }) {
      storage.removeItem(ACCESS_TOKEN);
      storage.removeItem(SPACE_TOKEN);
      yield put({
        type: 'updateState',
        payload: { user: {} },
      });
      setTimeout(() => {
        window.location = `${logoutUrl}?redirect=${window.location.origin}`;
      }, payload || 1);
    },
    * changeNavbar(__, { put, select }) {
      const { app } = yield (select(_ => _));
      const isNavbar = document.body.clientWidth < 769;
      if (isNavbar !== app.isNavbar) {
        yield put({ type: 'handleNavbar', payload: isNavbar });
      }
    },
    * selectPeriod({ payload }, { put }) {
      storage.setItem('period', payload);
      yield put({
        type: 'updateState',
        payload: { accountingPeriod: payload },
      });
      setTimeout(() => {
        window.location.reload();
      }, 800);
    },
    * initData(_, { put }) {
      yield [
        // put({ type: 'getUserProfile' }),
        put({ type: 'getSpaceUsers' }),
        put({ type: 'getSpaceSettings' }),

        put({ type: 'account/query' }),
        put({ type: 'group/query' }),
        put({ type: 'tag/query' }),
        put({ type: 'bankAccount/query' }),
        put({ type: 'itemUnit/query' }),
        put({ type: 'fileTag/query' }),

        put({ type: 'item/init' }),
        put({ type: 'contact/init' }),
        put({ type: 'employee/init' }),

        put({ type: 'notification/countUnreadNotification' }),
      ];
    },
  },
  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    setMessage(state, { payload }) {
      return {
        ...state,
        message: { ...payload },
      };
    },

    switchSider(state) {
      storage.setItem('siderFold', !state.siderFold);
      return {
        ...state,
        siderFold: !state.siderFold,
      };
    },

    switchTheme(state) {
      storage.setItem('darkTheme', !state.darkTheme);
      return {
        ...state,
        darkTheme: !state.darkTheme,
      };
    },

    switchMenuPopver(state) {
      return {
        ...state,
        menuPopoverVisible: !state.menuPopoverVisible,
      };
    },

    handleNavbar(state, { payload }) {
      return {
        ...state,
        isNavbar: payload,
      };
    },

    handleNavOpenKeys(state, { payload: navOpenKeys }) {
      return {
        ...state,
        ...navOpenKeys,
      };
    },

    setSpaceUsers(state, { payload }) {
      const users = {};
      console.log('setSpaceUsers', payload);
      payload && payload.forEach((item) => {
        item.userRole = getUserRole(item);
        item.appRole = getAppRole(item);
        if (item && item.id) users[item.id] = item;
      });
      return {
        ...state,
        users,
      };
    },

    setSpaceSettings(state, { payload }) {
      let beginPeriod = state.beginPeriod;

      if (payload.begin_period) {
        beginPeriod = payload.begin_period;
      }

      storage.setItem('beginPeriod', beginPeriod);

      return {
        ...state,
        // menu,
        settings: { ...payload },
        beginPeriod,
      };
    },

    updateSpaceSettings(state, { payload, merge = false }) {
      let settings;
      if (merge) {
        settings = lo.merge(state.settings, payload);
      } else {
        settings = { ...state.settings, ...payload };
      }
      return { ...state, settings };
    },

    setUserProfile(state, { payload }) {
      const userRole = getUserRole(payload);
      const appRole = getAppRole(payload);
      const user = { ...payload, userRole, appRole };
      if (appRole === 'manager') readonlyMenu.push({ id: '12', name: 'Thiết lập', icon: 'setting', route: '/settings' });
      return {
        ...state,
        user,
        appRole,
        userRole,
        menu: (userRole === UserRole.READONLY ? readonlyMenu : fullMenu),
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/app.js